import EmployerTrainingList from './EmployerTrainingList';

export default EmployerTrainingList;
